// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"252":"storage/builds/css/vuetifyFix","271":"storage/builds/css/app","429":"storage/builds/css/vuetifyFixRem"}[chunkId] + ".css";
};